import React, { useState, useContext, useEffect, useMemo } from 'react';
import ReactModal from 'react-modal';
import { AppContext } from '../../../../../../contexts/AppContext';
import { useStore } from '../../../../../../contexts/StoreContext';
import FindStoreAutocomplete from './FindStoreAutocomplete';
import StoreList from './StoreList';
import * as styles from './FindInStore.module.scss';
import './radar.scss';
import { useStoreContext } from './FindInStoreContext';
import useIsMobile from '../../../../../Hooks/useIsMobile';

function FindStoreModal({ isOpen, onRequestClose }) {
  const isMobile = useIsMobile();

  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    if (isMobile && isOpen) {
      let pos = $(document).scrollTop();

      return () => {
        $('.ReactModal__Body--open #root').css('position', 'relative');
        $('html, body').animate(
          {
            scrollTop: pos,
          },
          0
        );
      };
    }
  }, [isMobile, isOpen]);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={open}
      onRequestClose={onRequestClose}
      className={`${styles.slideInModal} ${open ? styles.slideInModalOpen : ''}`}
      overlayClassName={styles.slideInModalOverlay}
      ariaHideApp={false}
    >
      <FindStoreModalContent isOpen={open} onRequestClose={onRequestClose} />
    </ReactModal>
  );
}

function FindStoreModalContent({ isOpen, onRequestClose }) {
  const { stores, setStores } = useStoreContext();
  const { passedAppFunctions } = useContext(AppContext);
  const radarKey = passedAppFunctions.wasParms?.radarKey ?? '';
  const { selectedStore: globalSelectedStore, setSelectedStore: setGlobalStore } = useStore();
  const [selectedStore, setSelectedStore] = useState(globalSelectedStore);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const isDisabled = useMemo(() => {
    const isStoreInList = stores.some((store) => store.externalId === selectedStore?.externalId);
    return !selectedStore || !isStoreInList || loading || error;
  }, [stores, selectedStore, loading, error]);

  useEffect(() => {
    if (isOpen) {
      setSelectedStore(globalSelectedStore);
    }
  }, [isOpen, globalSelectedStore]);

  const handleSave = () => {
    if (selectedStore) {
      setGlobalStore(selectedStore);
      onRequestClose();
    }
  };

  return (
    <>
      <button className={styles.closeBtn} onClick={onRequestClose} aria-label='Close'>
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          role='img'
          aria-labelledby='closeStoreModal'
        >
          <title id='closeStoreModal'>Close</title>
          <path d='M20 4.59644L4 20.5964' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
          <path d='M4 4.59644L20 20.5964' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </button>
      <div className={styles.modalContent}>
        <h2 className={`${styles.modalTitle} mb-3 font-weight-bold`}>Set Your Store</h2>
        {isOpen && (
          <FindStoreAutocomplete
            radarKey={radarKey}
            setSearch={setSearch}
            setStores={setStores}
            setLoading={setLoading}
            setError={setError}
            selectedStore={selectedStore}
          />
        )}
        <div className={styles.scrollableListWrapper}>
          <div className={styles.storeList}>
            <StoreList stores={stores} selectedStore={selectedStore} onSelect={setSelectedStore} loading={loading} />
            {error && <div style={{ color: 'red' }}>{error}</div>}
          </div>
        </div>
      </div>
      <button
        className={`${styles.fixedSaveBtn} btn btn-primary`}
        role='button'
        type='button'
        onClick={handleSave}
        disabled={isDisabled}
      >
        Save
      </button>
    </>
  );
}

export default FindStoreModal;
